import { MouseEvent } from 'react'

import { Styles as S } from '~/pages/email/lib/components/AutoComplete/styles'

interface Props {
  domains: string[]
  handlePrefilledEmail: ({
    currentTarget,
  }: MouseEvent<HTMLButtonElement>) => void
}

const AutoComplete = ({ domains, handlePrefilledEmail }: Props) => (
  <S.Root>
    {domains.map((value) => (
      <S.Button
        type="button"
        key={value}
        value={value}
        onMouseDown={handlePrefilledEmail}
      >
        <S.Text>{value}</S.Text>
      </S.Button>
    ))}
  </S.Root>
)

export default AutoComplete
